import { useState } from "react";
import {
    TemplateId,
    DEFAULT_TESTIMONIALS,
    formatPhoneNumberForDisplay,
    resolveEffectiveHeadline,
    resolveEffectiveDescription,
    resolveEffectiveWcygCards,
    resolveEffectiveNoeParagraphs,
    resolveEffectiveCentivoCare,
    resolvePreviewImageSource,
} from "../../../../../../utils/planManager/preEnrollmentCustomUtils.js";

import phoneIcon from "../../../../../../assets/oe-preview/phone-icon.svg";
import centivoCareLogo from "../../../../../../assets/oe-preview/centivo-care-logo.svg";
import arrowIcon from "../../../../../../assets/oe-preview/arrow.svg";
import noeIllustration from "../../../../../../assets/oe-preview/home-network-of-excellence.svg";
import wcygMoney from "../../../../../../assets/oe-preview/wcyg-money.svg";
import wcygDoctor from "../../../../../../assets/oe-preview/wcyg-doctor.svg";
import wcygConcierge from "../../../../../../assets/oe-preview/wcyg-concierge.svg";
import wcygExperience from "../../../../../../assets/oe-preview/wcyg-experience.svg";
import chevronDownIcon from "../../../../../../assets/oe-preview/icon-chevron-down.svg";
import searchIcon from "../../../../../../assets/oe-preview/icon-search.svg";
import defaultHero from "../../../../../../assets/custom-default/default-hero.svg";
import defaultLogo from "../../../../../../assets/custom-default/default-logo.svg";
import defaultVideoThumb from "../../../../../../assets/oe-preview/hero-image-video.svg";
import playIcon from "../../../../../../assets/oe-preview/play-icon.svg";
import dashedBg from "../../../../../../assets/oe-preview/dashed-line.svg";
import externalLinkIcon from "../../../../../../assets/oe-preview/external-link.svg";

import "./Preview.scss";

const WCYG_ICONS = [wcygMoney, wcygDoctor, wcygConcierge, wcygExperience];

const SliceDownArrow = ({ color }) => (
    <svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17 15.7039C13.9084 15.4902 9.05013 17.0502 9.05013 25L9.05013 1.36211e-06M0.999998 15.7039C4.09161 15.4902 8.94986 17.0502 8.94986 25"
            stroke={color}
            strokeWidth="1.08868"
        />
    </svg>
);

const DoctorTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80" fill="currentColor">
        <g clipPath="url(#clip0_doctor)">
            <path d="M45.1399 29.98C36.8599 29.98 30.1299 23.25 30.1299 14.97C30.1299 6.69001 36.8599 -0.0399933 45.1399 -0.0399933C53.4199 -0.0399933 60.1499 6.69001 60.1499 14.97C60.1499 23.25 53.4199 29.98 45.1399 29.98ZM45.1399 0.960007C37.4099 0.960007 31.1299 7.25001 31.1299 14.97C31.1299 22.69 37.4199 28.98 45.1399 28.98C52.8599 28.98 59.1499 22.69 59.1499 14.97C59.1499 7.25001 52.8699 0.960007 45.1399 0.960007Z" fill="currentColor" />
            <path d="M75.3702 80.04C75.0902 80.04 74.8702 79.82 74.8702 79.54C74.8702 55.59 61.5402 36.11 45.1502 36.11C37.5202 36.11 30.2702 40.33 24.7202 48C24.5602 48.22 24.2502 48.27 24.0202 48.11C23.8002 47.95 23.7502 47.64 23.9102 47.41C29.6502 39.47 37.1902 35.1 45.1502 35.1C62.0902 35.1 75.8702 55.03 75.8702 79.53C75.8702 79.81 75.6502 80.03 75.3702 80.03V80.04Z" fill="currentColor" />
            <path d="M45.1402 58.07C37.3002 58.07 30.9102 51.69 30.9102 43.84V40.5C30.9102 40.22 31.1302 40 31.4102 40C31.6902 40 31.9102 40.22 31.9102 40.5V43.84C31.9102 51.13 37.8402 57.07 45.1402 57.07C52.4402 57.07 58.3702 51.14 58.3702 43.84V40.5C58.3702 40.22 58.5902 40 58.8702 40C59.1502 40 59.3702 40.22 59.3702 40.5V43.84C59.3702 51.68 52.9902 58.07 45.1402 58.07Z" fill="currentColor" />
            <path d="M26.4101 76.53C24.7001 76.35 23.0301 75.92 21.4501 75.25L21.8401 74.33C23.3301 74.96 24.9001 75.37 26.5201 75.54L26.4201 76.53H26.4101ZM31.5301 76.32L31.3401 75.34C32.9301 75.04 34.4601 74.5 35.9001 73.74L36.3701 74.62C34.8501 75.42 33.2201 76 31.5301 76.32ZM17.0701 72.57C15.7501 71.47 14.6101 70.17 13.6701 68.73L14.5101 68.18C15.4001 69.54 16.4801 70.76 17.7201 71.8L17.0801 72.57H17.0701ZM40.5001 71.59L39.7901 70.88C40.9401 69.74 41.9201 68.44 42.6801 67.01L43.5601 67.48C42.7401 68.99 41.7101 70.37 40.4901 71.59H40.5001ZM11.5301 64.08C11.0801 62.52 10.8501 60.89 10.8501 59.25V59.01H11.8501V59.25C11.8501 60.8 12.0701 62.33 12.4901 63.8L11.5301 64.08ZM45.3001 62.66L44.3201 62.46C44.5301 61.41 44.6301 60.33 44.6301 59.24V57.58H45.6301V59.24C45.6301 60.39 45.5201 61.54 45.3001 62.65V62.66Z" fill="currentColor" />
            <path d="M11.3499 55.34C7.91988 55.34 5.12988 52.55 5.12988 49.12C5.12988 45.69 7.91988 42.9 11.3499 42.9C14.7799 42.9 17.5699 45.69 17.5699 49.12C17.5699 52.55 14.7799 55.34 11.3499 55.34ZM11.3499 43.9C8.46988 43.9 6.12988 46.24 6.12988 49.12C6.12988 52 8.46988 54.34 11.3499 54.34C14.2299 54.34 16.5699 52 16.5699 49.12C16.5699 46.24 14.2299 43.9 11.3499 43.9Z" fill="currentColor" />
            <path d="M11.35 51.95C9.79002 51.95 8.52002 50.68 8.52002 49.12C8.52002 47.56 9.79002 46.29 11.35 46.29C12.91 46.29 14.18 47.56 14.18 49.12C14.18 50.68 12.91 51.95 11.35 51.95ZM11.35 47.29C10.34 47.29 9.52002 48.11 9.52002 49.12C9.52002 50.13 10.34 50.95 11.35 50.95C12.36 50.95 13.18 50.13 13.18 49.12C13.18 48.11 12.36 47.29 11.35 47.29Z" fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_doctor">
                <rect width="80" height="80" fill="currentColor" transform="translate(1.5)" />
            </clipPath>
        </defs>
    </svg>
);

const FacilityTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80" fill="currentColor">
        <path d="M45.4601 44.92H37.2601C36.9801 44.92 36.7601 44.7 36.7601 44.42V35.8H28.1401C27.8601 35.8 27.6401 35.58 27.6401 35.3V27.1C27.6401 26.82 27.8601 26.6 28.1401 26.6H36.7601V17.98C36.7601 17.7 36.9801 17.48 37.2601 17.48H45.4601C45.7401 17.48 45.9601 17.7 45.9601 17.98V26.6H54.5801C54.8601 26.6 55.0801 26.82 55.0801 27.1V35.3C55.0801 35.58 54.8601 35.8 54.5801 35.8H45.9601V44.42C45.9601 44.7 45.7401 44.92 45.4601 44.92ZM37.7601 43.92H44.9601V35.3C44.9601 35.02 45.1801 34.8 45.4601 34.8H54.0801V27.6H45.4601C45.1801 27.6 44.9601 27.38 44.9601 27.1V18.48H37.7601V27.1C37.7601 27.38 37.5401 27.6 37.2601 27.6H28.6401V34.8H37.2601C37.5401 34.8 37.7601 35.02 37.7601 35.3V43.92Z" fill="currentColor" />
        <path d="M40.5599 79.9C39.3499 79.9 38.1399 79.44 37.1999 78.53C33.0399 74.49 28.9299 70.07 24.6599 65.03L24.4099 64.73C16.5399 55.45 6.73989 43.9 7.56989 30.72C8.25989 19.76 15.1099 9.26 25.0199 3.97C29.7699 1.44 35.1299 0.110001 40.5399 0.110001C51.5599 0.110001 62.7399 6.5 69.0299 16.38C72.3499 21.6 73.8299 27.25 73.4099 33.16C73.0699 38 71.4699 43.01 68.6399 48.04C62.9999 58.07 54.8999 68.06 43.8599 78.58C42.9299 79.46 41.7399 79.91 40.5599 79.91V79.9ZM40.5399 1.11C35.2899 1.11 30.0899 2.41 25.4899 4.86C15.8799 9.98 9.23989 20.16 8.56989 30.78C7.76989 43.56 17.4199 54.94 25.1699 64.08L25.4199 64.38C29.6799 69.4 33.7599 73.79 37.8999 77.81C39.3699 79.24 41.6899 79.26 43.1699 77.84C54.1299 67.39 62.1799 57.48 67.7699 47.53C70.5199 42.63 72.0799 37.77 72.4099 33.07C72.8099 27.38 71.3799 21.94 68.1799 16.9C62.0699 7.31 51.2199 1.11 40.5399 1.11Z" fill="currentColor" />
    </svg>
);

const ProviderSearch = ({ disclaimer, selectedTemplate }) => {
    const [activeTab, setActiveTab] = useState(0);
    const isSlice = selectedTemplate === TemplateId.SLICE;
    const arrowColor = isSlice ? (activeTab === 0 ? "#F5F6D6" : "#F5F6D6") : "#D9FEBA";

    return (
        <div className={`preview--section provider--container ${isSlice ? "slice" : ""}`}>
            {selectedTemplate !== TemplateId.BASIC && !isSlice ? (
                <h3>Find a doctor or facility</h3>
            ) : null}
            <div className="tabs--container">
                <button
                    type="button"
                    className={`provider--tab ${activeTab === 0 ? "active" : ""}`}
                    onClick={() => setActiveTab(0)}
                >
                    <DoctorTabIcon />
                    <p>
                        Doctor
                        {activeTab === 0 ? <SliceDownArrow color={arrowColor} /> : null}
                    </p>
                </button>
                <button
                    type="button"
                    className={`provider--tab ${activeTab === 1 ? "active" : ""}`}
                    onClick={() => setActiveTab(1)}
                >
                    <FacilityTabIcon />
                    <p>
                        Facility
                        {activeTab === 1 ? <SliceDownArrow color={arrowColor} /> : null}
                    </p>
                </button>
                <div className="input--container">
                    <div className="custom-input icon-right">
                        <p>{activeTab === 0 ? "Select a specialty" : "Select a facility type (required)"}</p>
                        <img src={chevronDownIcon} alt="" />
                    </div>
                    <div className="custom-input">
                        <p>{`Search by ${activeTab === 0 ? "provider" : "facility"} name`}</p>
                        <img src={searchIcon} alt="" />
                        <p className="help">
                            The search field is sensitive to spelling and punctuation (like hyphens and apostrophes)
                        </p>
                    </div>
                    <div className="custom-input">
                        <p>ZIP code (required)</p>
                        <p className="help">Enter your ZIP code or the ZIP code for a nearby town.</p>
                    </div>
                    <button type="button" className="search-button" onClick={(e) => e.preventDefault()}>
                        Search
                    </button>
                </div>
                {disclaimer ? (
                    <p className="section--help">
                        The Centivo Network provider directory is updated regularly throughout the year. Please check that a provider is in-network for your plan by searching for them in the directory before your appointment or receiving care. If you need help searching for a provider, want to confirm a provider is in-network or if you think any information in the directory isn’t accurate, please call Centivo Member Care.
                    </p>
                ) : null}
            </div>
        </div>
    );
};

const DefaultPreview = ({ data, enabledFields }) => {
    const selectedTemplate = data.selectedTemplate || TemplateId.STANDARD;
    const logoSrc = resolvePreviewImageSource(data.logo, defaultLogo);
    const heroSrc = resolvePreviewImageSource(data.hero, defaultHero);
    const phoneDisplay = formatPhoneNumberForDisplay(data.phone);
    const headline = resolveEffectiveHeadline(data.headline, selectedTemplate);
    const wcygCards = resolveEffectiveWcygCards(data.withCentivo);
    const resolvedCare = resolveEffectiveCentivoCare(data.centivoCare);
    const noeParagraphs = resolveEffectiveNoeParagraphs(data.networkOfExcellence);

    return (
        <div className={`preview--container ${selectedTemplate}`}>
            <div className={`preview--navbar ${selectedTemplate}`}>
                <div className="navbar--content">
                    <div className="logo-container">
                        <img src={logoSrc} alt="Logo" />
                    </div>
                    <nav className="navbar--links">
                        <ul>
                            {data.phoneEnabled && data.phone ? (
                                <li>
                                    <a className="link" onClick={(e) => e.preventDefault()}>
                                        <img src={phoneIcon} alt="" />
                                        {phoneDisplay}
                                    </a>
                                </li>
                            ) : null}
                            {data.alreadyMember ? (
                                <li>
                                    <a className="link" onClick={(e) => e.preventDefault()}>
                                        Already a member?
                                    </a>
                                </li>
                            ) : null}
                        </ul>
                    </nav>
                </div>
            </div>

            <div
                className={`preview--section hero--section ${selectedTemplate}`}
                style={selectedTemplate === TemplateId.TAILORED ? { "--bg-img": `url(${dashedBg})` } : undefined}
            >
                <div className="hero--content">
                    <div className="left">
                        <h2>{headline}</h2>
                        <div className="hero--nav-container">
                            {data.heroButtonEnabled ? (
                                <button type="button" className="hero--button" onClick={(e) => e.preventDefault()}>
                                    {data.heroButtonText || "Hero button"}
                                </button>
                            ) : null}
                            {selectedTemplate !== TemplateId.BASIC ? (
                                <button type="button" className="hero--primary-button" onClick={(e) => e.preventDefault()}>
                                    Find a doctor or facility
                                </button>
                            ) : null}
                        </div>
                    </div>
                    <div className="video-container">
                        {data.hero ? (
                            <div><img src={heroSrc} alt="Hero" /></div>
                        ) : data.videoEnabled ? (
                            <div><img src={defaultVideoThumb} alt="doctor talking to her patient" /></div>
                        ) : (
                            <div><img src={defaultHero} alt="Hero" /></div>
                        )}
                        {data.videoEnabled ? (
                            <div className="play-icon">
                                <img src={playIcon} alt="play icon" className="play" />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            {enabledFields.withCentivo ? (
                <div className="preview--section wcyg--container">
                    <h4>With Centivo, you&apos;ll get:</h4>
                    <div className="content">
                        {wcygCards.map((text, i) => (
                            <div className="content-card" key={i}>
                                <img src={WCYG_ICONS[i]} alt="" />
                                <p>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            ) : null}

            {enabledFields.centivoCare && data.centivoCare && data.vpc ? (
                <div className="preview--section section--fluid centivo-care--section">
                    <div className="section-content">
                        <img className="centivo-care--logo" src={centivoCareLogo} alt="Centivo Care" />
                        <h3>{resolvedCare.title}</h3>
                        <p>{resolvedCare.body}</p>
                        <a onClick={(e) => e.preventDefault()}>
                            {resolvedCare.text} <img src={arrowIcon} alt="" />
                        </a>
                    </div>
                </div>
            ) : null}

            {enabledFields.networkOfExcellence ? (
                <div className="preview--section noe--container">
                    <div className="content">
                        <h3>A network of excellence</h3>
                        {noeParagraphs.map((text, i) => (
                            <p key={i}>{text}</p>
                        ))}
                    </div>
                    <div className="content">
                        <img src={noeIllustration} alt="Doctors and nurses" />
                    </div>
                </div>
            ) : null}

            <ProviderSearch
                disclaimer={Boolean(enabledFields.disclaimer && data.disclaimer)}
                selectedTemplate={selectedTemplate}
            />

            {enabledFields.testimonials && data.testimonials ? (
                <div className="preview--section section--fluid testimonials--section">
                    <div className="content">
                        <h3>Testimonials</h3>
                        <p className="testimonials--subtitle">See what our Centivo members have to say</p>
                        <div className="cards--container">
                            {DEFAULT_TESTIMONIALS.map((text, i) => (
                                <div className="testimonial--card" key={i}>
                                    <p>“{text}”</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : null}

            <footer />
        </div>
    );
};

const SlicePreview = ({ data, enabledFields }) => {
    const logoSrc = resolvePreviewImageSource(data.logo, defaultLogo);
    const phoneDisplay = formatPhoneNumberForDisplay(data.phone);
    const headline = resolveEffectiveHeadline(data.headline, TemplateId.SLICE);
    const description = resolveEffectiveDescription(data.description, TemplateId.SLICE);

    return (
        <div className="preview--container slice template-4">
            <div className="preview--navbar">
                <div className="navbar--content">
                    <img src={logoSrc} alt="Logo" />
                    <nav className="navbar--links">
                        <ul>
                            {data.phoneEnabled && data.phone ? (
                                <li>
                                    <a className="link" onClick={(e) => e.preventDefault()}>
                                        {phoneDisplay}
                                    </a>
                                </li>
                            ) : null}
                            {data.alreadyMember ? (
                                <li>
                                    <a className="link" onClick={(e) => e.preventDefault()}>
                                        Already a member?
                                    </a>
                                </li>
                            ) : null}
                        </ul>
                    </nav>
                </div>
            </div>

            <div className="preview--section hero--section">
                <div className="hero--content">
                    <h2>{headline}</h2>
                    <h3>{description}</h3>
                    {data.externalLinkEnabled ? (
                        <div className="external-link--container">
                            <button type="button" className="external-link" onClick={(e) => e.preventDefault()}>
                                {data.externalLinkLabel || "External link"}
                            </button>
                            <img className="upload-camera-img" src={externalLinkIcon} alt="External link" />
                        </div>
                    ) : null}
                </div>
            </div>

            <ProviderSearch
                disclaimer={Boolean(enabledFields.disclaimer && data.disclaimer)}
                selectedTemplate={TemplateId.SLICE}
            />

            <footer>
                <span>Terms of Use</span>
                <span>Privacy Policy</span>
            </footer>
        </div>
    );
};

const Preview = ({ data, enabledFields }) => {
    const isSlice = data.selectedTemplate === TemplateId.SLICE;

    return isSlice ? (
        <SlicePreview data={data} enabledFields={enabledFields} />
    ) : (
        <DefaultPreview data={data} enabledFields={enabledFields} />
    );
};

export default Preview;
